import ConversationM from '@/gf/modules/Conversation'
import { ConversationsQuery, useConversationsQuery } from '../_gen/gql'

const useConversations = ({
  filters,
  page = 1,
  pageSize = ConversationM.PAGE_SIZE,
  onCompleted,
  includeConversationId = null,
}: {
  filters: string[][]
  page?: number
  pageSize?: number
  vendorId?: string
  onCompleted?: (data: ConversationsQuery) => void
  includeConversationId?: string | null
}) => {
  const { loading, error, data, refetch } = useConversationsQuery({
    variables: { filters, page, pageSize, includeConversationId },
    pollInterval: ConversationM.CONVERSATION_POLL_INTERVAL,
    fetchPolicy: 'network-only',
    onCompleted,
  })

  return { loading, error, data: data?.conversations ?? null, refetch }
}

export default useConversations
